/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";
import Logo_Linkcampus from "../image/Logo_Linkcampus.png";
import ic_building_black from "../image/ic_building_black.png";
import ic_square_black from "../image/ic_square_black.png";
import ic_pen_white from "../image/ic_pen_white.png";

import { useNavigate } from "react-router-dom";
import Apply_Modal from "../Component/Apply_Modal";
import Apply_Modal2 from "../Component/Apply_Modal";

import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import Side_FMS from "./Side_FMS";
import Footer_FMS from "./Footer_FMS";
const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 85px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  padding: 10px;
  @media (max-width: 800px) {
    padding: 0px;
  }
`;
const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  padding: 15px 20px;
`;
const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
  }
`;
const Top_Button = styled.span`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  margin-left: 30px;
  cursor: pointer;
  color: #c0c0c0;
  transition: color 0.2s ease;
  &:hover {
    color: black;
  }
  @media (max-width: 800px) {
    font-size: 12px;
    margin-left: 15px;
  }
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};
  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;
const Column_div = styled.div`
  display: flex;
  width: 980px;
  flex-direction: column;
  @media (max-width: 800px) {
    width: 85%;
  }
`;
const Row_div = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Border_div = styled.div`
  width: 100%;
  height: 250px;
  display: grid;
  padding: 30px;
  align-self: center;
  margin-bottom: 15px;
  border-width: 2px;
  border-style: solid;
  border-radius: 16px;
  border-color: ${theme.colors.bgGray2};
  white-space: pre-line;

  @media (max-width: 800px) {
    width: 100%;
    height: 200px;
    padding: 15px;
    border-radius: 8px;
  }
`;
const Grid_div = styled.div`
  display: flex;
  flex-direction: column;
`;

const Main_Button = styled.button`
  background-color: #191919;
  width: 310px;
  height: 60px;
  border-radius: 8px;
  border-width: 0px;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  justify-self: flex-end;
  display: flex;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #777777;
  }
  @media (max-width: 800px) {
    width: 100%;
    height: 45px;
  }
`;
const Main_Button2 = styled.button`
  background-color: black;
  padding: 12px 25px;
  border-radius: 100px;
  border-width: 2px;
  border-color: black;
  border-style: solid;
  margin-top: 30px;
  margin-bottom: 100px;
  margin-right: 15px;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: white;
    ${Content_Text} {
      transition: color 0.3s ease;
      color: black;
    }
  }
`;
const Price_div = styled.div`
  justify-self: flex-end;
  align-self: flex-end;
  margin-top: 50px;
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
`;

const Footer_Bar = styled.div`
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  width: 1280px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;
const Footer_div = styled.div`
  justify-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 20%;
  @media (max-width: 800px) {
    width: 40%;
  }
`;
const Footer_Text2 = styled(Content_Text)`
  transition: color 0.2s ease;

  &:hover {
    color: #33cccc;
  }
`;
const UnderLine = styled.div`
  position: absolute;
  bottom: 0px;
  width: 70px;
  height: 2px;
  background-color: black;
  @media (max-width: 800px) {
    width: 41px;
    height: 1px;
  }
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  margin-right: 5px;
`;

function About() {
  const navigation = useNavigate();
  const [stan_modal, set_Stan_Modal] = useState(false);
  const [pre_modal, set_Pre_Modal] = useState(false);
  const open_Stan_Modal = () => set_Stan_Modal(true);
  const close_Stan_Modal = () => set_Stan_Modal(false);
  const open_Pre_Modal = () => set_Pre_Modal(true);
  const close_Pre_Modal = () => set_Pre_Modal(false);
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const open_privacy_policy = () => set_Privacy_Policy(true);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const open_terms = () => set_Terms(true);
  const close_terms = () => set_Terms(false);
  const go_Home = () => {
    navigation("/");
  };
  const go_About = () => {
    navigation("/about");
  };
  const go_Platform = () => {
    navigation("/Platform");
  };
  const go_Info = () => {
    navigation("/Info");
  };
  const go_Process = (item) => {
    navigation("/Process_FMS");
    window.scrollTo({ top: 0 });
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_div>
          <Logo_img
            onClick={() => {
              go_Home();
            }}
            src={Logo_Linkcampus}
            alt={Logo_Linkcampus}
          />
          <Top_Button
            onClick={() => {
              go_Info();
              window.scrollTo({ top: 0 });
            }}
          >
            회사소개
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_Process();
            }}
          >
            프로세스
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_Platform();
            }}
          >
            플랫폼
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_About();
              window.scrollTo({ top: 0 });
            }}
            style={{ color: "black" }}
          >
            제작문의
            <UnderLine />
          </Top_Button>
        </Header_div>
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                제작문의
              </Content_Text>
              <Footer_Text>
                링크캠퍼스만의 제작 경험과 노하우로 최고의 FMS 웹 사이트를
                제작해드립니다.
              </Footer_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Main_div>
          <Main_init_div>
            <Column_div>
              <Border_div $num={"1"}>
                <Grid_div>
                  <Row_div>
                    <Image
                      src={ic_building_black}
                      alt={ic_building_black}
                      $size={30}
                    />
                    <Content_Text $xbold style={{ fontSize: 28 }}>
                      Standard
                    </Content_Text>
                  </Row_div>
                  <Footer_Text $gray>
                    링크캠퍼스에서 제공하는 플랫폼을 기본으로 하여 유지보수와
                    서버비를 포함하는 FMS입니다.
                  </Footer_Text>
                </Grid_div>
                <Price_div>
                  <Content_Text $small $gray>
                    월별, 시설 1개당
                    <Content_Text
                      $blue2
                      $xmlarge
                      $xbold
                      style={{ marginTop: 30 }}
                    >
                      {" "}
                      100,000원 ~&nbsp;&nbsp;
                    </Content_Text>
                  </Content_Text>
                </Price_div>
                <Main_Button $num={"1"} onClick={open_Stan_Modal}>
                  <Row_div>
                    <Image
                      $size={windowSize.width > 800 ? 20 : 15}
                      src={ic_pen_white}
                      alt={ic_pen_white}
                    />
                    <Content_Text $white $bold>
                      문의하기
                    </Content_Text>
                  </Row_div>
                </Main_Button>
              </Border_div>
              <Border_div>
                <Grid_div>
                  <Row_div>
                    <Image
                      src={ic_square_black}
                      alt={ic_square_black}
                      $size={30}
                    />
                    <Content_Text $xbold style={{ fontSize: 28 }}>
                      Premium
                    </Content_Text>
                  </Row_div>
                  <Footer_Text $gray>
                    별도 제작이 필요한 FMS로 구축비용과 유지보수 및 서버버를
                    포함하는 FMS입니다.
                  </Footer_Text>
                </Grid_div>
                <Price_div>
                  <Content_Text $small $gray>
                    월별, 시설 1개당
                    <Content_Text
                      $blue2
                      $xmlarge
                      $xbold
                      style={{ marginTop: 30 }}
                    >
                      {" "}
                      별도 문의&nbsp;&nbsp;
                    </Content_Text>
                  </Content_Text>
                </Price_div>
                <Main_Button onClick={open_Pre_Modal}>
                  <Row_div>
                    <Image
                      $size={windowSize.width > 800 ? 20 : 15}
                      src={ic_pen_white}
                      alt={ic_pen_white}
                    />
                    <Content_Text $white $bold>
                      문의하기
                    </Content_Text>
                  </Row_div>
                </Main_Button>
              </Border_div>
            </Column_div>
          </Main_init_div>
        </Main_div>

        <Side_FMS />
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />

      <Terms_Modal show={terms} onClose={close_terms} />
      <Apply_Modal show={stan_modal} onClose={close_Stan_Modal} data={"stan"} />
      <Apply_Modal2 show={pre_modal} onClose={close_Pre_Modal} data={"pre"} />
    </Container>
  );
}

export default About;
